import { validateLength } from "./length.validate";

const validateField = (field, validationRules) => {
    if (field.dataset.novalidate) return { error: false };

    let value = field.value;

    /* type:number, валидация числа */
    if (field.type === "number") value = parseInt(value);

    return validateLength(value, validationRules);
};
  
const validateFormByRules = (form, validationRules, config = {}) => {
    let requiredFields = config.required || [];

    let hasErrors = false;
    let errors = {};
  
    let data = new FormData(form);
  
    for (let fieldName in validationRules) {
      if (validationRules.hasOwnProperty(fieldName)) {
        let result;

        let field = form.elements[fieldName];
        let rules = validationRules[fieldName];

        /* Одно поле, валидация значения */
        if (field && field instanceof HTMLElement) {
            result = validateField(field, rules);
        } else {
            let fieldsName = fieldName + '[]';
            let fields = form.elements[fieldsName];

            /* В форме нет такого поля */
            if (!fields) {
              if (requiredFields.indexOf(fieldName) !== -1 || requiredFields.indexOf(fieldsName) !== -1) {
                result = validateLength(null, rules);
              } else continue;
            } else {
              /* Несколько полей, валидация количества */
              let values = data.getAll(fieldsName).filter(value => value);
              result = validateLength(values, rules);
            }
        }
    
  
        if (result.error) {
          hasErrors = true;
          errors[fieldName] = result.error;
        }
      }
    }
  
    console.log('Errors', errors);
    return hasErrors ? errors : null;
};

export { validateFormByRules };